export const getMakesWithModelsOptions = ({makesWithModels = []}) =>
  makesWithModels.map(({make, models = []}) => ({
    id: make.id,
    label: make.name,
    models: models.map(({id, name}) => ({id, label: name}))
  }))

/**
 * Enriches user alert with make and model names
 * using optimized maps for O(1) lookup performance
 */
export const enrichUserAlertWithVehicleNames = ({userAlert, makesWithModels}) => {
  if (!makesWithModels?.length) {
    return userAlert
  }

  // Create optimized maps for O(1) lookup
  const makesMap = new Map()
  const modelsMap = new Map()

  // Single iteration to build both maps
  makesWithModels.forEach(({id: makeId, label: makeLabel, models}) => {
    if (makeId && makeLabel) {
      makesMap.set(String(makeId), makeLabel)

      // Create models map with composite key makeId:modelId
      models?.forEach(model => {
        if (model?.id && model?.label) {
          const key = `${makeId}:${model.id}`
          modelsMap.set(key, model.label)
        }
      })
    }
  })

  // Enrich alerts with names
  if (!userAlert?.filters?.vehicles?.length) {
    return userAlert
  }

  const enrichedVehicles = userAlert.filters.vehicles.map(vehicle => {
    const makeId = String(vehicle.makeId)
    const modelId = String(vehicle.model?.id || vehicle.modelId)
    const modelKey = `${makeId}:${modelId}`

    return {
      ...vehicle,
      make: makesMap.get(makeId) || null,
      model: {
        ...vehicle.model,
        id: vehicle.model?.id || vehicle.modelId,
        name: modelsMap.get(modelKey) || vehicle.model?.name || null
      }
    }
  })

  return {
    ...userAlert,
    filters: {
      ...userAlert.filters,
      vehicles: enrichedVehicles
    }
  }
}
